export { ModelRegistryModelVersionView } from './ModelRegistryModelVersionView';
export { LazyModelRegistryModelVersionView } from './LazyModelRegistryModelVersionView';
